export default __webpack_public_path__ + "static/media/2405_v1_500.e8bfed93.jpg";